import modalStyle from "../../modals/modal.module.scss";

import icn_btn_rediscover from "assets/images/icons/icn_btn_rediscover.svg";
import img_device_camera from "assets/images/icons/img_device_camera.svg";
import img_device_nvr from "assets/images/icons/img_device_nvr.svg";
import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";
import { ReactComponent as ShowIcon } from "assets/images/icons/icn_input_show_hover.svg";
import { ReactComponent as HideIcon } from "assets/images/icons/icn_input_hide.svg";

import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  InputAdornment,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

import ModalContainer from "components/ModalContainer";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";
import { getDefaultTableProp, getDefaultTextFieldProp } from "../../theme";
import { surveillanceDeviceTypeOption } from "../const";
const getResult = (device, results, loading) => {
  const result = results.find((item) => item.deviceId === device.deviceId);

  if (!result) {
    if (loading) {
      return <CircularProgress size={20} />;
    }

    return (
      <img
        src={icn_btn_rediscover}
        alt="discovery"
        style={{ width: "20px", height: "20px", marginRight: "5px" }}
      />
    );
  }

  return (
    <span style={{ color: result.isAuthenticated ? "#00FF00" : "#FF0000", fontWeight: "bold" }}>
      {result.isAuthenticated ? "Success" : "Failed"}
    </span>
  );
};

const DeviceTable = ({ currentStep, devices, results, loading }) => {
  const showResult = currentStep === 1;

  return (
    <div className={modalStyle.modal_Block} style={{ margin: "20px 0", maxHeight: "400px" }}>
      <TableContainer style={{ overflowY: "auto" }}>
        <Table>
          <TableHead sx={{ ...getDefaultTableProp().tableHead.sx }}>
            <TableRow sx={{ ...getDefaultTableProp().tableHead.tableRow.sx }}>
              <TableCell sx={{ ...getDefaultTableProp().tableHead.tableCell.text }}>
                Model Name
              </TableCell>
              <TableCell sx={{ ...getDefaultTableProp().tableHead.tableCell.text }}>
                MAC Address
              </TableCell>
              <TableCell sx={{ ...getDefaultTableProp().tableHead.tableCell.text }}>
                IP Address
              </TableCell>
              {showResult && (
                <TableCell sx={{ ...getDefaultTableProp().tableHead.tableCell.text }}>
                  Result
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <tbody>
            {devices.map((device, rowIndex) => {
              const isNvr = device.deviceType?.value === surveillanceDeviceTypeOption.nvr.value;

              return (
                <TableRow
                  key={`${device.deviceId}-row`}
                  sx={{ ...getDefaultTableProp(rowIndex).tableBody.tableRow }}
                >
                  <TableCell sx={{ ...getDefaultTableProp().tableBody.tableCell.text }}>
                    <Box display="flex" alignItems="center">
                      <img
                        src={isNvr ? img_device_nvr : img_device_camera}
                        alt=""
                        style={{ width: "60px", marginRight: "8px" }}
                      />
                      {device.modelName}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ ...getDefaultTableProp().tableBody.tableCell.text }}>
                    {device.deviceId}
                  </TableCell>
                  <TableCell sx={{ ...getDefaultTableProp().tableBody.tableCell.text }}>
                    {device.ipAddress}
                  </TableCell>
                  {showResult && (
                    <TableCell sx={{ ...getDefaultTableProp().tableBody.tableCell.text }}>
                      {getResult(device, results, loading)}
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </tbody>
        </Table>
      </TableContainer>
    </div>
  );
};

const AuthenticationFields = ({
  username,
  setUsername,
  password,
  setPassword,
  setAuthenticateStatus,
}) => {
  const [isPassword, setIsPassword] = useState(false);

  useEffect(() => {
    setAuthenticateStatus(username.length > 0 && password.length > 0);
  }, [username, password, setAuthenticateStatus]);

  return (
    <>
      <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
        <Box className={modalStyle["field-container"]} style={{ marginBottom: "10px" }}>
          <Box style={{ marginRight: "30px" }}>Username</Box>
          <Box className={modalStyle.item}>
            <Box style={{ width: "300px" }}>
              <TextField
                fullWidth
                type="text"
                value={username}
                autoComplete="new-password"
                onChange={(event) => setUsername(event.target.value)}
                sx={{ ...getDefaultTextFieldProp().sx }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
        <Box className={modalStyle["field-container"]}>
          <Box style={{ marginRight: "30px" }}>Password</Box>
          <Box className={modalStyle.item}>
            <Box style={{ width: "300px" }}>
              <TextField
                fullWidth
                type={isPassword ? "text" : "password"}
                value={password}
                autoComplete="new-password"
                onChange={(event) => setPassword(event.target.value)}
                sx={{ ...getDefaultTextFieldProp().sx }}
                InputProps={{
                  endAdornment: isPassword ? (
                    <InputAdornment position="end">
                      <ShowIcon onClick={() => setIsPassword(!isPassword)} style={{ cursor: "pointer" }} />
                    </InputAdornment>
                  ) : (
                    <InputAdornment position="end">
                      <HideIcon onClick={() => setIsPassword(!isPassword)} style={{ cursor: "pointer" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

const ModalAuthentication = ({
  display,
  currentStep,
  devices,
  results,
  loading,
  canClose,
  credential,
  setCredential,
  onCancel,
  onNext,
  onClose,
}) => {
  const [authenticateStatus, setAuthenticateStatus] = useState(false);

  return (
    <ModalContainer display={display} modalWidth="90p">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography color="#707ca8" fontWeight="600" fontSize="20px">
          Authentication
        </Typography>
        <Button
          disabled={currentStep === 1 && !canClose}
          onClick={() => {
            if (currentStep === 1 && !canClose) {
              return;
            }

            if (currentStep === 1) {
              onClose();
              return;
            }

            onCancel();
          }}
          className={`${currentStep === 1 && !canClose ? modalStyle.disabled_closeBtn : ""}`}
          sx={{
            marginRight: "-20px",
            backgroundColor: "transparent",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <CloseIcon />
        </Button>
      </Box>

      <DeviceTable currentStep={currentStep} devices={devices} results={results} loading={loading} />
      {currentStep === 0 && (
        <AuthenticationFields
          username={credential.username}
          setUsername={(username) => setCredential((prev) => ({ ...prev, username }))}
          password={credential.password}
          setPassword={(password) => setCredential((prev) => ({ ...prev, password }))}
          setAuthenticateStatus={setAuthenticateStatus}
        />
      )}
      <Box className={modalStyle.modal_operation}>
        {currentStep === 0 ? (
          <>
            <OutlineButton
              className={modalStyle.modal_cancelBtn}
              style={{ width: "195px", height: "42px", fontSize: "16px" }}
              variant="contained"
              onClick={onCancel}
            >
              Cancel
            </OutlineButton>
            <SolidButton
              className={`${modalStyle.modal_saveBtn} ${!authenticateStatus ? modalStyle.disabled_btn : ""}`}
              disabled={!authenticateStatus}
              style={{ width: "195px", height: "42px", fontSize: "16px" }}
              variant="contained"
              onClick={onNext}
            >
              Next
            </SolidButton>
          </>
        ) : (
          <SolidButton
            className={`${modalStyle.modal_saveBtn} ${!canClose ? modalStyle.disabled_btn : ""}`}
            disabled={!canClose}
            style={{ width: "195px", height: "42px", fontSize: "16px" }}
            variant="contained"
            onClick={onClose}
          >
            Close
          </SolidButton>
        )}
      </Box>
    </ModalContainer>
  );
};

export default ModalAuthentication;
